import React from 'react';

export default function Toast({ toast, onClose }) {
  const icons = { info: 'i', success: '✓', error: '!', warn: '!' };
  return (
    <div className={`toast ${toast.type}`}>
      <div className="ico">{icons[toast.type] || 'i'}</div>
      <div className="body">
        {toast.title && <div className="title">{toast.title}</div>}
        {toast.msg && <div className="msg">{toast.msg}</div>}
      </div>
      <button className="close" onClick={onClose} aria-label="Close">×</button>
    </div>
  );
}
